import { render } from "./operat.vue?vue&type=template&id=3956d9fc&scoped=true&ts=true"
import script from "./operat.vue?vue&type=script&lang=tsx"
export * from "./operat.vue?vue&type=script&lang=tsx"

import "./operat.vue?vue&type=style&index=0&id=3956d9fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3956d9fc"]])

export default __exports__